// extracted by mini-css-extract-plugin
export default {"highlightedRow":"StatementDownloadsModal_highlightedRow__5vnyR"};